<template>
  <div class="rounded pa-3" style="border: 1px dashed #DFDFDF; background-color: #FAFAFA; cursor: pointer;">
    <v-img :height="height" :src="imgPreview" @click="$refs.FileInput.click()" contain content-class="img-content">
      <template v-slot:placeholder>
        <div class="d-flex justify-center align-center fill-height text-body-2 text--secondary">
          <v-icon left>mdi-cloud-upload</v-icon>
          {{ placeholder }}
        </div>
      </template>
    </v-img>
    <input @input="onFileSelect" accept="image/*" ref="FileInput" style="display: none" type="file" />

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-text>
          <VueCropper
            :aspect-ratio="aspectRatio"
            :src="selectedFile"
            alt="Source Image"
            ref="cropper"
            v-show="selectedFile"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn @click="cropImage()" class="primary">Crop</v-btn>
          <v-btn @click="dialog = false" color="primary" text>Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  name: "ImageCropUpload",

  components: { VueCropper },

  props: {
    height: {
      type: Number,
      default: 60,
    },
    aspectRatio: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: "Select image",
    },
  },

  data() {
    return {
      mimeType: "",
      croppedImage: "",
      autoCrop: false,
      selectedFile: null,
      image: "",
      dialog: false,
      files: "",
      imgPreview: null,
    };
  },

  methods: {
    cropImage() {
      this.croppedImage = this.$refs.cropper.getCroppedCanvas()?.toDataURL();
      if (!this.croppedImage) {
        return;
      }
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        this.dialog = false;

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.imgPreview = reader.result;
          const blobToFile = new File([blob], "logo.png", {
            type: this.mimeType,
          });
          this.$emit("crop", { blobToFile, blob: this.imgPreview });
        };
      }, this.mimeType);
    },

    onFileSelect(e) {
      if (!e.target.files?.length) {
        return;
      }
      const file = e.target.files[0];
      this.mimeType = file.type;
      if (typeof FileReader === "function") {
        this.dialog = true;
        const reader = new FileReader();
        reader.onloadend = (event) => {
          const cropper = this.$refs.cropper;
          this.selectedFile = event.target.result;
          cropper.replace(this.selectedFile);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
      this.$refs.FileInput.value = "";
    },
  },
};
</script>

<style scoped>
.image-box {
  border: 1px solid #bababa;
  position: relative;
  overflow: hidden;
}
div >>> .img-content {
  max-width: 300px;
}
</style>
